module.exports = __webpack_public_path__ + "static/media/wordmark_white.22f0fb48.svg";